import React from 'react';
import imagemLogoCirculo from "../../../assets/images/logoProfileCirculo.png";

const AdnThankYouComponent = (isPTLanguage) => {
    return (
        <div className="container-wrapper" style={{height:"100vh"}}>
            <div className="container">
                <div className="formBackground">
                    <div className="formContainer">
                        <div id="main">
                            <div className="text-center">
                                {isPTLanguage === true ? "OBRIGADO" : "THANK YOU"}
                                <div className="thanksLogo">
                                    <img src={imagemLogoCirculo} alt="Thank You Logo" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdnThankYouComponent;